import React, { useState, useEffect } from "react";
import Loader from "../Loader";
import axios from "axios";
import AccessDenied from "../AccessDenied";
import NoContent from "../NoContent";
import domainURLs from "../urls";
import VideoViewer from "./VideoViewer";
import PDFViewer from "./PDFViewer";
import "./Viewer.css";

const App = () => {
  const [loading, setLoading] = useState(true);
  const [accessDenied, setAccessDenied] = useState(false);
  const [noContent, setNoContent] = useState(false);
  const [data, setData] = useState({});
  const [contentUrl, setContentUrl] = useState("");
  const [date, setDate] = useState("");
  const [type, setType] = useState("video");
  const [filename, setFileName] = useState("sample");
  const [rating, setRating] = useState(0);

  let days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ];
  const isMobile = () => {
    if (
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    )
      return true;
    else return false;
  };

  const initialCalls = async () => {
    try {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      if (Object.keys(params).length) {
        let str = params.att_id ? "att_id" : "id";
        if (!params || !params[str]) {
          setAccessDenied(true);
        } else {
          const headers = {
            "x-api-key": "GQIgOomJbT9QawpdNLfT5ALieUyf5mmH6R2NZhN4",
            "Content-Type": "application/json"
          };

          const { data } = await axios.get(
            `${domainURLs.REACT_APP_FETCH_DETAILS}?view=true&attachment_keys=${params[str]}`,
            {
              headers
            }
          );

          setData(data);
          if (!data || !data.enterpriseDetails) setAccessDenied(true);
          else if (
            !data ||
            !data.data ||
            !data.data[params[str]] ||
            !data.data[params[str]].url
          )
            setNoContent(true);
          else {
            setContentUrl(data.data[params[str]].url);
            setDate(data.data[params[str]].message_created_datetime);
            setType(data.data[params[str]].type);
            setFileName(data.data[params[str]].name);
            setRating(data.data[params[str]].isRated);
          }
        }
      } else {
        let pathname = window.location.pathname.split("/");
        let id = pathname.pop();
        let url =
          "http://" +
          window.location.host +
          "/" +
          pathname[1] +
          "/" +
          "?id=" +
          id;
        window.location.replace(url);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      setNoContent(true);
    }
  };
  useEffect(() => {
    (async () => {
      await initialCalls();
    })();
  }, []);

  const dayString = () => {
    if (date) {
      let dayName = days[((new Date(date).getDay() + 6) % 7) + 1];
      let daytime = formatAMPM(new Date(date));
      let dayDate = date.split("T")[0].split("-");
      dayDate = dayDate.length
        ? dayDate[1] + "/" + dayDate[2] + "/" + dayDate[0]
        : null;
      return daytime + " " + dayName + ", " + dayDate;
    }
  };

  const formatAMPM = date => {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    let strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  };

  return (
    <div>
      {loading ? (
        <Loader />
      ) : !accessDenied ? (
        !noContent ? (
          <div
            className={
              isMobile() ? "viewerMainDiv" : "viewerMainDiv desktopView"
            }
          >
            {type === "video" ? (
              <VideoViewer
                src={contentUrl}
                entName={
                  data && data.enterpriseDetails
                    ? data.enterpriseDetails.storeName
                      ? data.enterpriseDetails.storeName
                      : data.enterpriseDetails.entName
                    : null
                }
                date={dayString()}
                name={filename}
                isMobile={isMobile()}
                data={data}
                rating={rating}
              />
            ) : (
              <PDFViewer
                src={contentUrl}
                entName={
                  data && data.enterpriseDetails
                    ? data.enterpriseDetails.storeName
                      ? data.enterpriseDetails.storeName
                      : data.enterpriseDetails.entName
                    : null
                }
                date={dayString()}
                name={filename}
                isMobile={isMobile()}
                data={data}
                rating={rating}
              />
            )}
          </div>
        ) : (
          <NoContent />
        )
      ) : (
        <AccessDenied />
      )}
    </div>
  );
};

export default App;
// App;
